export enum UserStepStateType {
  Completed = 'Listo',
  InProcess = 'En proceso',
  Pending = 'Pendiente',
  PendingValidation = 'Por validar',
  Rejected = 'Rechazado',
}
